<template>
	<div>
		<div class="u-container">
			<FindPasswordForm
				v-if="page === 1"
				@nextPage="nextPage"
			></FindPasswordForm>
			<FindPasswordUpdate
				v-if="page === 2"
				@nextPage="nextPage"
			></FindPasswordUpdate>
			<FindPasswordResult v-if="page === 3"></FindPasswordResult>
		</div>
	</div>
</template>

<script>
import FindPasswordForm from './form';
import FindPasswordUpdate from './updateForm';
import FindPasswordResult from './result';

export default {
	components: {
		FindPasswordForm,
		FindPasswordUpdate,
		FindPasswordResult,
	},
	data() {
		return {
			page: 1,
		};
	},
	methods: {
		nextPage() {
			this.page++;
		},
	},
};
</script>
